import React from 'react'

import box from '/public/img/caixa.png'
import paper from '/public/img/papeis.png'

import './index.less'

export const AnimatedImages = () => (
  <div className='animated-images'>
    <div id='box'>
      <img id='box-img' src={box} />
    </div>
    <div id='paper'>
      <img id='paper-img' src={paper} />
    </div>
  </div>
)
